import { layerProperties } from './layer-store'
let adminOpacity;

layerProperties.subscribe(prop => {
    adminOpacity = prop
})
export const getLayerProperties=(id)=>{
    return adminOpacity.find(item => item.id === id)
}
export const setLayerProperties = (id) => {
    function setItem(jsonObj, id, property, value) {
        for (var i = 0; i < jsonObj.length; i++) {
            if (jsonObj[i].id === id) {
                jsonObj[i][property] = value;
            }
        }
        return jsonObj
    }
    layerProperties.update(prop => {
        let itemUpdate = prop.find(item => item.id === id)['active']
        return setItem(prop, id, 'active', !itemUpdate)
    })
    return
}
export const setLayerProperties2= (id,property) => {
    function setItem(jsonObj, id, property, value) {
        for (var i = 0; i < jsonObj.length; i++) {
            if (jsonObj[i].id === id) {
                jsonObj[i][property] = value;
            }
        }
        return jsonObj
    }
    layerProperties.update(prop => {
        let itemUpdate = prop.find(item => item.id === id)[property]
        return setItem(prop, id, property, !itemUpdate)
    })
    return
}
export const setLayerProperties3 = (id,property,value) => {
    function setItem(jsonObj, id, property, value) {
        for (var i = 0; i < jsonObj.length; i++) {
            if (jsonObj[i].id === id) {
                jsonObj[i][property] = value;
            }
        }
        return jsonObj
    }
    layerProperties.update(prop => {
        return setItem(prop, id, property, value)
    })
    return
}